<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Edit Lab",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Edit Lab",
            items: [
               {
                  text: "Lab",
                  href: "/labs",
               },
               {
                  text: "Edit Lab",
                  active: true,
               },        
            ],

            collecting_range: '',
            lab: {
               id: "",
               name : "",
               address: "",
               mobile: "",
               email: "",
               display_time: 1,
               type: 1,         // default to Individual
               clinic_id: null, // only required if type == 2
            },

            password_confirmation: '',
            password: '',
            countries: [],
            clinics: [],        // list of clinics for the dropdown

            image: "",
            preview_image: "",
            //lab_location: 'Kochi, Kerala, India',
            lab_marker: { position: { lat: '', lng: '' } },
            lab_center: { lat: '', lng: '' },
            lab_current_place: null,
            lab_content_A: "",
            lab_content_B: "",
            lab_mapOptions: {
               disableDefaultUI: true,
            },
            computed: {
               collectingRangeWithoutUnit() {
                  return this.collecting_range.replace(/\s*km\s*$/, '');    
               },
            },

            errors: {},
            
            loading: false,
         };
      },
      mounted() {
         this.fetchCountryCodes();
         this.fetchClinics();
         this.fetchContents();
      },

      created() {
         this.fetchLab();
      },

      methods: {


         fetchLab(){

            let url = "api/admin/lab/details?id=" + this.$route.params.id;
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;

               // Use responseData.lab and responseData.bookings_count
               this.lab =  responseData.lab;
               this.lab_marker.position.lat = parseFloat(responseData.lab.latitude);
               this.lab_marker.position.lng = parseFloat(responseData.lab.longitude); 


               this.lab_center.lat = parseFloat(responseData.lab.latitude);
               this.lab_center.lng = parseFloat(responseData.lab.longitude); 


               this.collecting_range = responseData.lab.collecting_range + " km";

               //this.labfetchPlace(lab_center);

               //console.log(res.data.data);


            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));
         },

          fetchContents() {
            let url = "api/admin/getContents";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.lab_content_A = responseData.contents.lab_content_A;
                  this.lab_content_B = responseData.contents.lab_content_B;
                  console.log(this.contents);
               })
               .catch((err) => console.log(err));
         },

         labUpdate(){
            //console.log('labUpdate method called');

            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/lab/update";

            let formData = new FormData();
            formData.append("id", this.lab.id);
            formData.append("name", this.lab.name);
            formData.append("email", this.lab.email);
            formData.append("mobile", this.lab.mobile);
            formData.append("address", this.lab.address);
            formData.append("country_code", this.lab.country_code_id); 
            //formData.append("location", this.lab.email);
            formData.append("latitude", this.lab_marker.position.lat);
            formData.append("longitude", this.lab_marker.position.lng);
            formData.append("collecting_range", this.collecting_range.replace(/\s*km\s*$/, ''));
            formData.append("type", this.lab.type);
            if (this.lab.type == 2) {
               formData.append("clinic_id", this.lab.clinic_id);
            }
            formData.append("limited_tokens", this.lab.limited_tokens);
            formData.append("limited_tokens_count", this.lab.limited_tokens_count);
            formData.append("content_type", this.lab.content_type);
            formData.append("token_management_type", this.lab.token_management_type);
            if(this.image) {
               formData.append('image', this.image);
            }

            this.loading = true;
            
               this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'labs' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false))



         },
         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         fetchClinics() {
            let url = "api/admin/tv_show/getClinics?type=" + 1;
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  this.clinics = res.data.data.clinics;
               })
               .catch((err) => console.log(err));
         },


         changePassword(){


            this.getToken();

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/lab/change-password";
            let formData = new FormData();
            formData.append("id", this.lab.id);
            formData.append("password", this.password);
            formData.append("password_confirmation", this.password_confirmation);

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'labs' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               this.fetchLabDetail();


         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         
         //sets the position of marker when dragged
         labHandleMarkerDrag(e) {
            this.lab_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         labPanToMarker() {
            this.$refs.labMapRef.panTo(this.lab_marker.position);
            this.$refs.labMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         labHandleMapClick(e) {
            this.lab_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         labSetPlace(place) {
            this.lab_current_place = place;
            if(this.lab_current_place) {
               const marker = {
                  lat: this.lab_current_place.geometry.location.lat(),
                  lng: this.lab_current_place.geometry.location.lng(),
               };
               this.lab_center = marker;
               this.lab_marker.position = marker;
               this.lab_location = place.formatted_address;
            }
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         /*labfetchPlace(lab_center) {
            if (this.lab_center) {
               const marker = {
                     lat: this.lab_center.lat,
                     lng: this.lab_center.lng,
               };
               this.lab_center = marker;
               this.lab_marker.position = marker;
               this.lab_location = lab_center.formatted_address;
            }
         },*/
      }
   }
</script>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'labs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent = "labUpdate">
                        
                        <div class="row">
                           
                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Place<span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.address" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></b-form-input>
                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Phone</label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="lab.country_code_id"  v-bind:class="{ 'is-invalid': Boolean(errors.country_code) }">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                              <b-form-input v-model="lab.mobile" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                              <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Email<span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 
                                 <img class="avatar-md mb-2" v-if="lab.image" :src="$image_url + lab.image" alt="">
                                 <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                                 <p class="small">(Leave this field empty if you don't want to change the image)</p>
                                 <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                                 <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 
                              </div>
                              
                           </div>
                        </b-card>
                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location <span class="text-danger">*</span></label>
                              <GmapAutocomplete @place_changed="labSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here..."  :value="lab_location"/>
                              
                              <GmapMap v-if="lab_location"
                                 :center="lab_center"
                                 :zoom="18"
                                 map-style-id="lab-roadmap"
                                 :options="lab_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="labMapRef"
                                 @click="labHandleMapClick">
                                    <GmapMarker
                                       :position="lab_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="labHandleMarkerDrag"
                                       @click="labPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="4" xl="4" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="lab_marker.position.lat"></b-form-input>
                           </b-col>

                           <b-col md="4" xl="4" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="lab_marker.position.lng"></b-form-input>
                           </b-col>
                           <b-col md="4" xl="4" class="form-group" v-if ="lab.token_management_type == 1">
                              <label class="control-label">Collecting Range <span class="text-danger">*</span></label>
                              <b-form-input v-model="collecting_range"> </b-form-input>
                           </b-col>
                           <b-col md="6" xl="4" class="form-group">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model="lab.type"
                                 name="labType"
                                 :class="{ 'is-invalid': Boolean(errors.type) }"
                                 inline
                                 >
                                 <div class="form-check-inline">
                                 <b-form-radio :value="1">Individual</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                 <b-form-radio :value="2">Under Clinic</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="6" xl="4" class="form-group" v-if="lab.type == 2">
                              <label class="control-label">Clinic <span class="text-danger">*</span></label>
                              <select v-model="lab.clinic_id" class="form-control" :class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                                <option value="">Select Clinic</option>
                                <option v-for="clinic in clinics" :key="clinic.id" :value="clinic.id">{{ clinic.name }}</option>
                              </select>
                              <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>  

                             <b-col md="12" class="form-group">
                              
                              <div class="row">
                                 <div class="col-md-6">
                                    <div class="card border" :class="{ 'border-primary': lab.content_type === 1 }">
                                       <div class="card-body">
                                          <div class="form-check">
                                             <input class="form-check-input" type="radio" v-model="lab.content_type" :value="1" name="labContentType" :class="{ 'is-invalid': Boolean(errors.content_type) }">
                                             <label class="form-check-label fw-bold">
                                                Content A
                                             </label>
                                          </div>
                                          <div class="mt-2">
                                             <small class="text-muted">{{ lab_content_A || 'No content available' }}</small>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 
                                 <div class="col-md-6">
                                    <div class="card border" :class="{ 'border-primary': lab.content_type === 2 }">
                                       <div class="card-body">
                                          <div class="form-check">
                                             <input class="form-check-input" type="radio" v-model="lab.content_type" :value="2" name="labContentType" :class="{ 'is-invalid': Boolean(errors.content_type) }">
                                             <label class="form-check-label fw-bold">
                                                Content B
                                             </label>
                                          </div>
                                          <div class="mt-2">
                                             <small class="text-muted">{{ lab_content_B || 'No content available' }}</small>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                              <div v-for="(val, index) in errors.content_type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                        <b-row v-if ="lab.token_management_type == 2">
                           <b-col md="6" xl="4" class="form-group d-flex align-items-center">
                              <b-form-checkbox
                                 v-model="lab.limited_tokens"
                                 name="limited_tokens"
                                 value="1"
                                 unchecked-value="2"
                              >
                                 <span class="ms-2">Limited Tokens</span>
                              </b-form-checkbox>
                           </b-col>

                           <b-col md="6" xl="4" class="form-group" v-if="lab.limited_tokens==1">
                              <label class="control-label">Token Count<span class="text-danger">*</span></label>
                              <b-form-input v-model="lab.limited_tokens_count" v-bind:class="{ 'is-invalid': Boolean(errors.limited_tokens_count) }"></b-form-input>
                               <div v-for="(val, index) in errors.limited_tokens_count" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>

                         <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Token Management Type <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model="lab.token_management_type"
                                 name="labTokenType"
                                 :class="{ 'is-invalid': Boolean(errors.token_management_type) }"
                                 inline
                                 >
                                 <div class="form-check-inline">
                                 <b-form-radio :value="1">Schedule-based token management system</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                 <b-form-radio :value="2">Current token tracking</b-form-radio>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.token_management_type" :key="index" class="invalid-feedback d-block">
                                <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col> 

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'labs' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>


                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent = "changePassword">
                        <h4 class="font-size-16 mb-4">Change Password</h4>
                        <div class="row">

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" v-if="!edit">
                              <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password_confirmation" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>
                              <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Update</button>
                              <router-link :to="{ name: 'labs' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>
